const getDeeplinkToken = (): string => {
  const params = new URL(window.location.toString()).searchParams;
  const tk = params.get("tk");

  return tk ? "tk=" + tk : "";
};

export default getDeeplinkToken;
